/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPresentationLayerObject = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6.28 16V8.73h2.6c.893 0 1.566.207 2.02.62.46.413.69 1.027.69 1.84 0 .807-.23 1.42-.69 1.84-.454.413-1.127.62-2.02.62H7.83V16zm2.28-6h-.73v2.38h.73c.533 0 .91-.09 1.13-.27.226-.187.34-.493.34-.92 0-.433-.114-.74-.34-.92-.22-.18-.597-.27-1.13-.27zm3.989 6V8.73h2.79c.866 0 1.533.2 2 .6.467.4.7.967.7 1.7 0 .513-.134.95-.4 1.31-.26.36-.63.617-1.11.77l1.82 2.89h-1.72l-1.54-2.61-.99-.25V16zm1.55-3.88h.76c.607 0 1.027-.077 1.26-.23.24-.16.36-.437.36-.83s-.12-.667-.36-.82c-.233-.16-.653-.24-1.26-.24h-.76z" />
        <path d="M2 22V2h20v20zm2-2h16V4H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgPresentationLayerObject as PresentationLayerObject };
